import React from "react";
import "../Css/Recordings.css";
import Card from "./Card";
import thumbnail1 from "../Images/thumbnail1.jpeg";
import thumbnail2 from "../Images/thumbnail2.jpeg";
import thumbnail3 from "../Images/thumbnail3.jpeg";
import thumbnail4 from "../Images/thumbnail4.jpeg";
import thumbnail5 from "../Images/thumbnail5.jpeg";
import thumbnail6 from "../Images/thumbnail6.jpeg";
import video1 from "../Videos/video1.mp4";
import video2 from "../Videos/video2.mp4";
import video3 from "../Videos/video3.mp4";
import video4 from "../Videos/video4.mp4";
import video5 from "../Videos/video5.mp4";
import video6 from "../Videos/video6.mp4";
export default function Recordings() {
  class CardContent {
    constructor(title, description, image, link, video) {
      this.title = title;
      this.description = description;
      this.image = image;
      this.link = link;
      this.video = video;
    }
  }
  const card1 = new CardContent(
    "الطباخة عبير",
    "عبير الصغير: من هاوية طبخ إلى محترفة🧑🏻‍🍳",
    thumbnail1,
    "https://www.tiktok.com/@dotmediajo/video/7099133618802478338?is_from_webapp=1&sender_device=pc&web_id=7094370560436291074",
    video1
  );
  const card2 = new CardContent(
    "قضية جوني ديب",
    "محكمة زي الأفلام!",
    thumbnail2,
    "https://www.tiktok.com/@dotmediajo/video/7101776150506032385?is_from_webapp=1&sender_device=pc&web_id=7094370560436291074",
    video2
  );
  const card3 = new CardContent(
    "أعلان زين",
    "نحليل أعلان زين لرمضان",
    thumbnail3,
    "https://www.tiktok.com/@dotmediajo/video/7091334136698277122?is_from_webapp=1&sender_device=pc&web_id=7094370560436291074",
    video3
  );
  const card4 = new CardContent(
    "الثلج",
    "لعبة الثلج",
    thumbnail4,
    "https://www.tiktok.com/@kasset_dawwar/video/7058335417493441794?is_from_webapp=1&sender_device=pc&web_id=7094370560436291074",
    video4
  );
  const card5 = new CardContent(
    "رأس السنة",
    "الفرق بين اول يوم و آخر يوم",
    thumbnail5,
    "https://www.tiktok.com/@kasset_dawwar/video/7046002008620420354?is_from_webapp=1&sender_device=pc&web_id=7094370560436291074",
    video5
  );
  const card6 = new CardContent(
    "الاسئلة الصعبة",
    "هل هي حماقة؟",
    thumbnail6,
    "https://www.tiktok.com/@kasset_dawwar/video/7100205865512258817?is_from_webapp=1&sender_device=pc&web_id=7094370560436291074",
    video6
  );
  return (
    <div className="Recordings-container" id="recordings">
      <section>
        <h1>تسجيلاتي مع دوت ميديا</h1>
        <div className="cards-container">
          <Card content={card1} />
          <Card content={card2} />
          <Card content={card3} />
        </div>
      </section>
      <section>
        <h1>خواطري</h1>
        <div className="cards-container">
          <Card content={card4} />
          <Card content={card5} />
          <Card content={card6} />
        </div>
      </section>
    </div>
  );
}
